/* eslint-disable default-case */
/* eslint-disable func-names */
import { Howl, Howler } from 'howler';
import vars from '../globals';
import cardAudio from './card-audio';

const $btns = $('.composition__play');
const $stop = $('.composition__stop');
let mixerStartTime = 0;
let playing = false;
let play30secInterval = null;
const audioLengthMs = 10000;
const switches = {};

const preset = {
	songs: [
		['audio/bass-1.ogg', 'audio/bass-1.mp3'],
		['audio/bass-2.ogg', 'audio/bass-2.mp3'],
		['audio/bass-3.ogg', 'audio/bass-3.mp3'],
		['audio/bass-4.ogg', 'audio/bass-4.mp3'],

		['audio/beat-1.ogg', 'audio/beat-1.mp3'],
		['audio/beat-2.ogg', 'audio/beat-2.mp3'],
		['audio/beat-3.ogg', 'audio/beat-3.mp3'],
		['audio/beat-4.ogg', 'audio/beat-4.mp3'],

		['audio/lead-1.ogg', 'audio/lead-1.mp3'],
		['audio/lead-2.ogg', 'audio/lead-2.mp3'],
		['audio/lead-3.ogg', 'audio/lead-3.mp3'],
		['audio/lead-4.ogg', 'audio/lead-4.mp3'],

		['audio/porsche-1.ogg', 'audio/porsche-1.mp3'],
		['audio/porsche-4.ogg', 'audio/porsche-4.mp3'],
		['audio/porsche-6.ogg', 'audio/porsche-6.mp3'],
		['audio/porsche-7.ogg', 'audio/porsche-7.mp3'],
	],
};
const audioCache = {};

const mute = (element) => {
	audioCache[element.data('mix')].volume(0);

	element.removeClass('mix-await');
	element.removeClass('mix-playing');

	if ($btns.filter('.mix-playing').length === 0) {
		$stop.slideUp({
			duration: 200,
			start: () => $stop.addClass('hide'),
		});
	}
};

const mixerReady = () => {
	$(window).one('click', () => {
		Object.keys(audioCache).forEach((k) => {
			audioCache[k].play();
		});
	});

	$('.composition').one('click', () => {
		mixerStartTime = new Date().getTime();
	});

	$stop.on('click', (e) => {
		e.preventDefault();
		vars.$document.trigger('beatmaker-stop');
		clearInterval(play30secInterval);

		mixerStop();
	});

	const onKeyDown = (event) => {
		const el = $btns.filter(`[data-mix=${keyToSampleIndex(event.keyCode)}]`)[0];

		if (el !== undefined && el !== null) {
			playSample($(el), 'key');
			cardAudio.cardAudioStop();
		}
	};

	if (window.addEventListener) {
		window.addEventListener('keydown', onKeyDown, true);
	} else if (document.attachEvent) {
		document.attachEvent('onkeydown', onKeyDown);
	} else {
		document.addEventListener('keydown', onKeyDown, true);
	}

	$btns.on('click', (e) => {
		e.preventDefault();

		cardAudio.cardAudioStop();
		playSample($(e.currentTarget), 'click');
	});
};

const keyToSampleIndex = function (key) {
	let index = -1;

	switch (key) {
		case 81: index = 0; break;
		case 87: index = 1; break;
		case 65: index = 2; break;
		case 83: index = 3; break;
		case 69: index = 4; break;
		case 82: index = 5; break;
		case 68: index = 6; break;
		case 70: index = 7; break;
		case 84: index = 8; break;
		case 89: index = 9; break;
		case 71: index = 10; break;
		case 72: index = 11; break;
		case 85: index = 12; break;
		case 73: index = 13; break;
		case 74: index = 14; break;
		case 75: index = 15; break;
	}

	return index;
};

export const mixerInit = function () {
	preset.songs.forEach((v, k) => {
		const audio = new Howl({
			src: v,
			autoplay: false,
			loop: true,
			volume: 0,
			usingWebAudio: true,
			onplayerror: () => {
				audioCache[k].once('unlock', () => {
					audioCache[k].play();
				});
			},
		});

		audio.once('load', () => {
			if (Howler.ctx && Howler.ctx.state && Howler.ctx.state === 'suspended') {
				Howler.ctx.resume().then(() => {
					// eslint-disable-next-line no-console
					console.log('AudioContext resumed!');
				});
			}
			audioCache[k] = audio;
			if (Object.keys(audioCache).length === preset.songs.length) {
				mixerReady();
			}
		});
	});
};

export const mixerStop = function () {
	$stop.slideUp({
		duration: 200,
		start: () => $stop.addClass('hide'),
	});

	$btns.removeClass('mix-await');

	const $playing = $btns.filter('.mix-playing');

	Object.keys(switches).forEach((v) => {
		clearTimeout(switches[v]);
	});

	$playing.each((k, v) => {
		mute($(v));
	});
};

const playSample = function (el, type) {
	const index = el.data('mix');
	const group = el.data('group');
	const $group = $btns.filter(`[data-group=${group}]`);

	if (audioCache[index] instanceof Howl) {
		vars.$document.trigger('beatmaker-track-type', [`${group} - ${index}`, type]);

		if (!playing) {
			clearInterval(play30secInterval);

			vars.$document.trigger('beatmaker-play');

			play30secInterval = setInterval(() => {
				vars.$document.trigger('beatmaker-30sec');
			}, 30000);
			playing = true;
		}

		if (el.hasClass('mix-playing')) {
			mute(el);

			setTimeout(() => {
				if (!$btns.hasClass('mix-playing')) {
					vars.$document.trigger('beatmaker-stop');
					clearInterval(play30secInterval);
					playing = false;
				}
			}, 100);
		} else {
			// Получаем остаток от четверти мелодии для выставления паузы переключения
			let wait = audioLengthMs / 4 - audioCache[index].seek() * 1000 % (audioLengthMs / 4);

			$group.filter('.mix-playing').each((k, v) => {
				$(v).addClass('mix-await');
			});

			if (switches[group]) {
				$group.filter('.mix-await').each((k, v) => {
					v = $(v);
					if (!v.hasClass('mix-playing')) {
						v.removeClass('mix-await');
					}
				});
				clearTimeout(switches[group]);
				delete switches[group];
			}

            el.addClass('mix-await');

			switches[group] = setTimeout(() => {
				$group.each((k, v) => {
					mute($(v));
				});
				el.removeClass('mix-await');
				el.addClass('mix-playing');
				audioCache[index].volume(0.5);

				if ($btns.filter('.mix-playing').length >= 2) {
					$stop.slideDown({
                        duration: 200,
                        start: () => $stop.removeClass('hide')
                    });
				}

				delete switches[group];
			}, wait);
		}
	}
};
